var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.934,
    y: 2.019,
    width: 4.131,
    height: 10.965,
    rx: 2.066,
    ry: 2.066
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.348,4.847c-2.226,1.703-3.668,4.38-3.668,7.399,0,5.148,4.173,9.32,9.32,9.32s9.32-4.173,9.32-9.32c0-3.02-1.442-5.696-3.668-7.399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.31215558920af5f8da60fb45bb27a127.svg";
export { ForwardRef as ReactComponent };